/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idRoletaCheckin: string;
}

export function useSortearInscricao() {
  const postData = async (props: Props) => {
    const SORTEAR_INSCRICAO = `${leadsWebEnviroment}/common/checkin/recepcao/sortear/v1/${props.idRoletaCheckin}`;
    const response = await instance.post(SORTEAR_INSCRICAO);
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => { },
    onError: () => { },
  });

  return mutation;
}
